import * as React from "react";
import { connect } from "react-redux";
import { Routine } from "redux-saga-routines";
import { Action, ActionFunctionAny } from "redux-actions";
import { defineMessages, MessageDescriptor, useIntl } from "react-intl";
import moment from "moment";
import {DeviceHardwareEnum, isGx8, isSTCB} from "@Safemate/DeviceHardwareEnum";
import { getBatteryIcon } from "@Safemate/DeviceList/DeviceList/utils";
import List from "@Elements/SpacedList";
import {fetchSensors, syncDevice, updateSensors} from "../Store/routines";
import { mapFunction } from "./sensorFunction";
import { ErrorStatus, mapStatus, SensorStatusEnum } from "./sensorStatus";
import { mapRssi } from "./sensorRssi";
import { mapType } from "./sensorType";
import { AddWrap, WrapDiv } from "./styles";
import { ISensor, ISensorDTO } from "./types";
import Tooltip from "@Elements/Tooltip";
import { mapActions } from "./sensorActions";
import { LoaderWrap, SubLoader } from "@Safemate/Spinner";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { DescriptionParagraph, NoSensorWrapper } from "./Add/styles";
import { SensorTypeEnum } from "./SensorTypeEnum";
import Loader from "@Elements/Loader";
import { useHistory, useLocation, useParams, useRouteMatch } from "react-router";
import { AppState } from "@Safemate/Store/types";
import { SensorName } from "./sensorName";
import { SetHoverRow, setHoverRow } from "../Store/actions";
import { DoorClosed, DoorOpen } from "@Elements/Icon/Icons/FontAwesome";
import { isDoorAware } from "./SensorFunctionEnum";
import { IconWrap } from "@Safemate/DeviceList/DeviceList/TableElements";

enum SensorTableElements{
  STATUS,
  TYPE,
  NAME,
  FUNCTION,
  SERIAL_NUMBER,
  DOOR_STATUS,
  MAC,
  RSSI,
  LAST_CONTACT,
  BATTERY,
  ACTIONS
}

const SAFEMATE_HOME: SensorTableElements[] = [
  SensorTableElements.STATUS,
  SensorTableElements.TYPE,
  SensorTableElements.NAME,
  SensorTableElements.FUNCTION,
  SensorTableElements.SERIAL_NUMBER,
  SensorTableElements.DOOR_STATUS,
  SensorTableElements.RSSI,
  SensorTableElements.LAST_CONTACT,
  SensorTableElements.ACTIONS
]

const SAFEMATE_HOME_STCB: SensorTableElements[] = [
  SensorTableElements.STATUS,
  SensorTableElements.TYPE,
  SensorTableElements.NAME,
  SensorTableElements.SERIAL_NUMBER,
  SensorTableElements.LAST_CONTACT,
]

const SAFEMATE_HOME_DT35 = SAFEMATE_HOME;
const SAFEMATE_HOME_MAX = SAFEMATE_HOME;
const SAFEMATE_HOME_STCB1 = SAFEMATE_HOME_STCB;

const TRIGGER_FOUR: SensorTableElements[] = [
  SensorTableElements.STATUS,
  SensorTableElements.BATTERY,
  SensorTableElements.TYPE,
  SensorTableElements.MAC,
  SensorTableElements.RSSI,
  SensorTableElements.ACTIONS
]

const TRIGGER_THREE_E = TRIGGER_FOUR
const WATCH_FOUR = TRIGGER_FOUR
const TRACK_TWO = TRIGGER_FOUR


const tableElements: Map<DeviceHardwareEnum, SensorTableElements[]> = new Map<DeviceHardwareEnum, SensorTableElements[]>([
  [DeviceHardwareEnum.SAFEMATE_HOME, SAFEMATE_HOME],
  [DeviceHardwareEnum.SAFEMATE_HOME_DT35, SAFEMATE_HOME_DT35],
  [DeviceHardwareEnum.SAFEMATE_HOME_MAX, SAFEMATE_HOME_MAX],
  [DeviceHardwareEnum.SAFEMATE_HOME_STCB1, SAFEMATE_HOME_STCB1],
  [DeviceHardwareEnum.SAFEMATE_HOME_STCB3, SAFEMATE_HOME_STCB1],
  [DeviceHardwareEnum.TRIGGER_FOUR, TRIGGER_FOUR],
  [DeviceHardwareEnum.TRIGGER_THREE_E, TRIGGER_THREE_E],
  [DeviceHardwareEnum.WATCH_FOUR, WATCH_FOUR],
  [DeviceHardwareEnum.TRACK_TWO, TRACK_TWO]
]);

interface SensorTableProps{
  dehaId: number;
  deviId: number;
  sensorRefresh: number;
  sensors: ISensorDTO[];
  updatingName: number[];
  updatingType: number[];
  updatingFunction: number[];
  fetchSensors: Routine<ActionFunctionAny<Action<any>>>; 
  updateSensors: Routine<ActionFunctionAny<Action<any>>>;
  syncDevice: Routine<ActionFunctionAny<Action<any>>>;
  setHoverRow: SetHoverRow;
  hoverRow: number;
  loadingSensors: boolean;
}

export interface Params{
  name: string;
}


const SensorTable = (
  {dehaId, 
  deviId,
  sensorRefresh,
  sensors, 
  updatingName, 
  updatingType, 
  updatingFunction, 
  fetchSensors, 
  updateSensors,
  syncDevice,
  hoverRow,
  setHoverRow,
  loadingSensors}: SensorTableProps) => {

  const { formatMessage } = useIntl();

  React.useEffect(() => {
    fetchSensors({deviId, init: true});
    updateSensors(deviId);

    const refresh = setInterval(() => {
      fetchSensors({deviId})
    }, sensorRefresh * 1000)

    return () => {
      clearTimeout(refresh);
    }

  }, [])

  const {url} = useRouteMatch();
  const params = useParams<Params>();

  const addlink = `${url.split(params.name)[0]}add`;

  const setHover = (item: any) => {
    const sensorId = item[0].id;
    if(sensorId && sensorId != hoverRow){
      setHoverRow(sensorId);
    }
  }
  const setLeaveHover = (item: any) => {
    setHoverRow(0);
  }

  const syncDeviceClick = () => {
    syncDevice(deviId);
  }

  if(loadingSensors) return <SubLoader/>

  if(sensors.length === 0){
    return(
      <NoSensorWrapper>
        <h3>{formatMessage({id: "noSensors", defaultMessage: "Det er ingen sensorer lagt til denne enheten"})}</h3>
        { !isSTCB(dehaId) && <AddWrap>
        <Link to={addlink}>
          <Button>
            {formatMessage({id: "missionTaskAddSensor", defaultMessage: "Legg til ny sensor"})}
          </Button>
        </Link>
      </AddWrap> }
      { isSTCB(dehaId) && <AddWrap>
        <Button onClick={syncDeviceClick}>
          {formatMessage({id: "updateDevice", defaultMessage: "Oppdater"})}
        </Button>
      </AddWrap> }
      </NoSensorWrapper>
    )
  }
  
  return(
    <React.Fragment>
      { !isSTCB(dehaId) && <AddWrap>
        <Link to={addlink}>
          <Button>
            {formatMessage({id: "missionTaskAddSensor", defaultMessage: "Legg til ny sensor"})}
          </Button>
        </Link>
      </AddWrap> }
      { isSTCB(dehaId) && <AddWrap>
        <Button onClick={syncDeviceClick}>
          {formatMessage({id: "updateDevice", defaultMessage: "Oppdater"})}
        </Button>
      </AddWrap> }
      {sensors.length === 0
        ? <DescriptionParagraph>
            {formatMessage({id: "noSensors", defaultMessage: "Det er ingen sensorer lagt til denne enheten"})}
          </DescriptionParagraph>
        : <List
            onMouseOver={setHover}
            onMouseLeave={setLeaveHover}
            header={mapHeader(dehaId, formatMessage)}
            content={mapContent(dehaId, sensors, updatingName, updatingType, updatingFunction, formatMessage)}
          />}
    </React.Fragment>
  )
}


const mapStatetoProps = ({ appSettings: { sensorRefresh }, settings: {initialization: { deviId, dehaId }, sensor: { loadingSensors, hoverRow, sensors, updatingName, updatingType, updatingFunction }}}: AppState) => {
  return {
    sensors,
    dehaId,
    deviId,
    updatingName, 
    updatingType, 
    updatingFunction,
    sensorRefresh,
    hoverRow,
    loadingSensors
  }
}

const mapDispatchToProps = {
  fetchSensors,
  updateSensors,
  syncDevice,
  setHoverRow
}

export default connect(mapStatetoProps, mapDispatchToProps)(SensorTable);

const header = defineMessages({
  mac: { id: 'macAddress', defaultMessage: 'Mac addresse' },
  name: { id: 'sensTableHeadName', defaultMessage: 'Navn' },
  type: { id: "type", defaultMessage: "Type"},
  function: { id: 'sensTableHeadFunction', defaultMessage: 'Funksjon'},
  serialNumber: { id: 'sensTableHeadSerialNumber', defaultMessage: 'Serienummer'},
  lastContact: { id: 'sensTableHeadLastContact', defaultMessage: 'Sist kontakt'},
  actions: { id: 'sensTableHeadActions', defaultMessage: 'Handlinger'},
  rssi: { id: 'signalStrength', defaultMessage: 'Signalstyrke'},
  status: { id: 'sensTableHeadStatus', defaultMessage: 'Status'},
  battery: { id: 'battery', defaultMessage: 'Batteri'},
});

type MapHeader = (dehaId: DeviceHardwareEnum, formatMessage: (message: MessageDescriptor) => string) => any[];

const mapHeader: MapHeader = (dehaId, formatMessage) => {
  const elements = tableElements.get(dehaId);
  if(!elements) return [];
  
  return elements.map(element => {
    switch(element){
      case SensorTableElements.STATUS:
        return {text: formatMessage(header.status), align: "center"};
      case SensorTableElements.TYPE:
        return {text: formatMessage(header.type), align: "center"};
      case SensorTableElements.NAME:
        return {text: formatMessage(header.name), width: "25%"};
      case SensorTableElements.FUNCTION:
        return {text: formatMessage(header.function), align: "center"};
      case SensorTableElements.SERIAL_NUMBER:
        return {text: formatMessage(header.serialNumber)};
      case SensorTableElements.DOOR_STATUS:
        return {text: ""}
      case SensorTableElements.MAC:
        return {text: formatMessage(header.mac)}
      case SensorTableElements.RSSI:
        return {text: formatMessage(header.rssi), align: "center"};
      case SensorTableElements.BATTERY:
        return {text: formatMessage(header.battery), align: "center"};
      case SensorTableElements.ACTIONS:
        return {text: formatMessage(header.actions)};
      default:
        return null;
    }
  }).filter(item => item);
}

const isLoading = (sensor: ISensor, updatingName: number[], updatingType: number[], updatingFunction: number[]) => {
  return updatingName.includes(sensor.deseId) || updatingType.includes(sensor.deseId) || updatingFunction.includes(sensor.deseId)
}

const isPendingLocalLearn = (sensor: ISensorDTO) => {
  return sensor.sensor.type === SensorTypeEnum.SAFEMATE_HOME
    && sensor.status
    && sensor.status.icon === SensorStatusEnum.PENDING_LOCAL_LEARN;
}

const PendingCell = () => <LoaderWrap><Loader/></LoaderWrap>;

type MapContent = (dehaId: DeviceHardwareEnum, sensors: ISensorDTO[], updatingName: number[], updatingType: number[], updatingFunction: number[], formatMessage: (message: MessageDescriptor) => string) => any;

const mapContent: MapContent = (dehaId, sensors, updatingName, updatingType, updatingFunction, formatMessage) => {
  const elements = tableElements.get(dehaId);
  if(!elements) return [];

  return sensors.filter((sensor: ISensorDTO) => filterSensors(sensor))
    .map((sensor: ISensorDTO) => {
    if(sensor.sensor.type === SensorTypeEnum.SAFEMATE_HOME && isLoading(sensor.sensor, updatingName, updatingType, updatingFunction)){
      return [
        {text: <LoaderWrap><Loader/></LoaderWrap>, colspan: SAFEMATE_HOME.length}
      ]
    }
    return elements.map((element, index) => {
      const pendingLocalLearn = isPendingLocalLearn(sensor);
      switch(element){
        case SensorTableElements.STATUS:
          return  {id: sensor.sensor.deseId, text: <IconWrap
                        key={`sensor-${index}`}
                        error={ErrorStatus.includes(sensor.status.icon as SensorStatusEnum)}
                      >
                        {mapStatus(sensor, formatMessage)}
                      </IconWrap>};
        case SensorTableElements.TYPE:
          return {text: pendingLocalLearn ? <PendingCell/> : mapType(sensor)};
        case SensorTableElements.NAME:
          return {text: <SensorName sensorId={sensor.sensor.deseId} name={sensor.sensor.name}/>};
        case SensorTableElements.FUNCTION:
          return {text: pendingLocalLearn ? <PendingCell/> : mapFunction(sensor)};
        case SensorTableElements.SERIAL_NUMBER:
          return {text: mapSerialNumber(sensor)};
        case SensorTableElements.DOOR_STATUS:
          return {text: mapDoorStatus(sensor, formatMessage)};
        case SensorTableElements.MAC:
          return {text: mapMac(sensor)};
        case SensorTableElements.RSSI:
          return {text: mapRssi(sensor, formatMessage)};
        case SensorTableElements.BATTERY:
          return {text: mapBattery(sensor)};
        case SensorTableElements.ACTIONS:
          return {text: mapActions(sensor), preventClick: true}
        default:
          return null;
      }
    }).filter(item => item)
  });
}

const filterSensors = ({sensor}: ISensorDTO) => {
  switch(sensor.type){
    case SensorTypeEnum.BASE_STATION:
    case SensorTypeEnum.WRIST_BAND:
      return sensor.saved;
    default: return true;
  }
}

const mapSerialNumber = (sensor: ISensorDTO) => {
  switch(sensor.sensor.type){
    case SensorTypeEnum.SAFEMATE_HOME:{
      // Scanned sensors carry the serial in gatewayId; manually-added sensors carry it in
      // macAddress (gatewayId is null until the hub reports back), so fall back to macAddress.
      let snNum = sensor.sensor.gatewayId || sensor.sensor.macAddress;
      if (!snNum) {
        return null;
      }
      if (snNum.endsWith('0')) {
        return snNum.slice(0, -1);
      }
      return snNum;
    }
    
    default: return null;
  }
}

const mapDoorStatus = (sensor: ISensorDTO, formatMessage: (message: MessageDescriptor) => string) => {

  if(isDoorAware(sensor.function ? sensor.function.code : null)){ 
    switch(sensor.sensor.statusDoor){
      case -1:
        return (
        <Tooltip
          popoverId="door_closed_popover"
          labelId="doorClosed"
          defaultMessage="Døren er lukket"
        >
          <DoorClosed title={formatMessage({id: "doorClosed", defaultMessage: "Døren er lukket"})} mediumSecondary/>
        </Tooltip>)
      case 1:
        return (
        <Tooltip
          popoverId="door_oepn_popover"
          labelId="doorOpen"
          defaultMessage="Døren er åpen"
        >
          <DoorOpen title={formatMessage({id: "doorOpen", defaultMessage: "Døren er åpen"})} mediumSecondary/>
        </Tooltip>)
      default:
        return null;
    }
  }
  return null;
}


const mapMac = (sensor: ISensorDTO) => {
  switch(sensor.sensor.type){
    case SensorTypeEnum.BASE_STATION:
    case SensorTypeEnum.WRIST_BAND:
      return sensor.sensor.macAddress;

    default: return null;
  }
}

const mapLastContact = (sensor: ISensorDTO, formatMessage: (message: MessageDescriptor) => string) => {
  const unknownYearFromDevice = 1970;
  switch(sensor.sensor.type){
    case SensorTypeEnum.SAFEMATE_HOME:
      return sensor.sensor.lastContact && moment.utc(sensor.sensor.lastContact).year() > unknownYearFromDevice
        ? moment.utc(sensor.sensor.lastContact).format('DD.MM.YYYY HH:mm')
        : formatMessage({id: "unknown", defaultMessage: "Ukjent"});

    default: return null;
  }
}

const mapBattery = (sensor: ISensorDTO) => {

  switch(sensor.sensor.type){
    case SensorTypeEnum.WRIST_BAND:
    case SensorTypeEnum.WRIST_BAND:
      const {battery, connectedStateDate} = sensor.sensor;
      return battery 
        ? <Tooltip
            popoverId={`battery_popover`}
            labelId={`${battery}%`}
            defaultMessage={`${battery}% (${moment(connectedStateDate).format("DD.MM.YYYY HH:mm")})`}
          >
            <WrapDiv>
              {getBatteryIcon(battery, false)}
            </WrapDiv>
          </Tooltip> 
        : null;

    default: return null;
  }
}
